/**
 * Credits (docs/spec/04 §6): the game, its version, who is in it, how it was made, and the tribute -
 * the one place the 1981 game is named.
 */

import { GAME_NAME, TRIBUTE } from '../../app/brand';
import { RED } from '../../render/palette';
import type { Screen } from '../../render/screen';
import { drawSprite } from '../../render/sprites';
import { UiScene } from '../kit/base';
import { drawLogo } from '../kit/logo';
import { logoWidth } from '../kit/logoModel';
import { ACCENT, CX, INK, MUTED, SELECTED, W, wingFrame } from '../kit/theme';
import type { MenuAction } from '../scene';
import { CAST_LINES, chaseX, creditLines, tributeLines } from './creditsModel';
import { versionLabel } from './titleMenu';

const LOGO_Y = 34;
const VERSION_Y = 72;
const LINES_Y = 90;
const CHASE_Y = 160;
const TRIBUTE_Y = 180;
const THANKS_Y = 246;
const THANKS = 'THANK YOU FOR PLAYING';
const PACK = ['stinger', 'moth', 'monarch'] as const;

export class CreditsScene extends UiScene {
  protected readonly heading = 'CREDITS';

  protected override describe(): string {
    return `Credits. ${GAME_NAME}, version ${this.services.version}. ${creditLines().join(' ')} ${TRIBUTE}`;
  }

  protected override hint(): string {
    return `${this.words().back} BACK`;
  }

  protected paint(screen: Screen): void {
    drawLogo(screen, GAME_NAME, Math.floor((W - logoWidth(GAME_NAME)) / 2), LOGO_Y, this.ms, null);
    screen.text(`VERSION ${versionLabel(this.services.version).slice(1)}`, CX, VERSION_Y, ACCENT, 'center');
    creditLines().forEach((line, i) => {
      screen.text(line, CX, LINES_Y + i * 10, i < CAST_LINES ? SELECTED : INK, 'center');
    });
    // The Lancer crosses the screen with the hive on its tail.
    const x = chaseX(this.ms, W);
    drawSprite(screen, 'lancer', 0, x, CHASE_Y, 0);
    PACK.forEach((id, i) => {
      const bob = Math.round(Math.sin(this.ms / 260 + i * 1.7) * 3);
      drawSprite(screen, id, wingFrame(this.ms), x - 44 - i * 22, CHASE_Y + bob, 0);
    });
    tributeLines().forEach((line, i) => screen.text(line, CX, TRIBUTE_Y + i * 10, MUTED, 'center'));
    const left = CX - ((THANKS.length + 2) * 8) / 2;
    screen.text(THANKS, left, THANKS_Y, INK);
    screen.text('♥', left + (THANKS.length + 1) * 8, THANKS_Y, RED);
  }

  protected onAction(a: MenuAction): void {
    if (a === 'confirm') this.back();
  }
}
